import cx from 'classnames'
import Icon from 'components/shared/Icon'
import withStyles from '@material-ui/core/styles/withStyles'
import MuiButton from '@material-ui/core/Button'
import React from 'react'

const ContainedButton = ({
  href = null,
  buttonCxNames,
  selected,
  title,
  iconName,
  hideIcon = false,
  isProxy = false
}) => (
  <Button
    href={href}
    className={cx('w-100 h3 ma0 ph5 outline-0')}
    variant='contained'
    classes={{ root: buttonCxNames }}
    disabled={selected || isProxy}
  >
    <div className={cx('w-100 flex items-center justify-between', { white: selected }, { 'cadet-blue': !selected })}>
      <div>
        {title}
      </div>
      {iconName && !hideIcon && (
        <Icon
          name={iconName}
          className={cx(
            'h-100 w7',
            { 'svg-fill-cadet-blue': !selected },
            { 'svg-fill-white': selected }
          )}
        />
      )}
    </div>
  </Button>
)

const Button = withStyles({
  root: {
    height: '3rem',
    border: 'solid 1px #6288a5 !important',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0,140,159,0.15)'
    }
  }
})(MuiButton)

export default ContainedButton
